/** QuickHouse — Panneau latéral droit : propriétés de la sélection */
import { useProjectStore } from '../store/useProjectStore.js';
import { PropertiesPanel } from './Toolbar.jsx';

export default function RightPanel() {
  const selection = useProjectStore((s) => s.selection);

  return (
    <div className="side-right">
      <div className="rp-tabs">
        <button className="active">Propriétés</button>
      </div>
      <div className="rp-body">
        <PropertiesPanel />
        {!selection.length && (
          <div style={{ color: 'var(--text-dim)', fontSize: 12, lineHeight: 1.6 }}>
            Sélectionnez un élément (plan 2D, ou via l'arborescence « Contenu »)
            pour afficher et modifier toutes ses propriétés ici.
          </div>
        )}
      </div>
    </div>
  );
}
